import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HistoryState } from '@store/reducers/history.reducer';

export const selectHistoryState = createFeatureSelector<HistoryState>('history');

export const selectHistoryItems = createSelector(selectHistoryState, (state: HistoryState) => state.items);
